
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm1.32-15.202H9.24v-.836h3.08v.836zm3.078-.13h-1.996v-.982c0-.224-.196-.406-.44-.406H9.037c-.244 0-.441.182-.441.406v.983H6.6c-.244 0-.441.182-.441.405 0 .224.197.406.44.406h8.798c.244 0 .442-.182.442-.406 0-.223-.198-.405-.442-.405zm-1.33 1.692a.448.448 0 00-.452.443v6.705a.33.33 0 01-.332.326H7.837a.33.33 0 01-.332-.326V8.803a.448.448 0 00-.452-.443.448.448 0 00-.453.443v6.705c0 .668.555 1.212 1.237 1.212h5.446c.683 0 1.237-.544 1.237-1.212V8.803a.448.448 0 00-.452-.443zm-3.58 5.736V8.784c0-.234-.263-.424-.588-.424-.325 0-.589.19-.589.424v5.312c0 .234.264.424.589.424.325 0 .589-.19.589-.424zm2.201 0V8.784c0-.234-.264-.424-.59-.424-.324 0-.588.19-.588.424v5.312c0 .234.264.424.588.424.326 0 .59-.19.59-.424z","fill":"#515358","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/photosForm/delete.svg